import { Box } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

// Components
import YesNoQuestion from '../../../../flows/src/components/ui/advisory-flow/components/shared-components/YesNoQuestion';
import CancelButton from './CancelButton';

interface Props {
  onContinue: () => void;
  onContinueWithForm: () => void;
  onCancel: () => void;
}

const CancelInsurance: React.FC<React.PropsWithChildren<Props>> = ({
  onCancel,
  onContinue,
  onContinueWithForm,
}) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Title>
        {t('Would you like to cancel your current insurance policy?')}
      </Title>
      <Text>
        {t(
          'If you answer no to this step, the offer will be added to your chosen offers but the letter of termination will not be generate automatically',
        )}
      </Text>
      <Box w="100%">
        <YesNoQuestion handleNo={onContinue} handleYes={onContinueWithForm} />
      </Box>
      <StyledCancelButton onClick={onCancel} />
    </Wrapper>
  );
};

const StyledCancelButton = styled(CancelButton)`
  margin-top: 1.6rem;
`;

const Text = styled.p`
  color: ${({ theme }) => theme.labels.guaranteeText};
  font-size: 1.6rem;
  line-height: 120%;
  margin-bottom: 2.4rem;
`;

const Title = styled.h1`
  font-weight: 500;
  font-size: 1.8rem;
  margin-bottom: 1.6rem;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export default CancelInsurance;
